import React from 'react';
import { TextField } from '@mui/material';

const DateTimeComponent = ({label, selectedDate, setSelectedDate}) => {

  const now = new Date();
  const year = now.getFullYear();
  const month = String(now.getMonth() + 1).padStart(2, '0'); 
  

  const firstDayOfMonth = `${year}-${month}-${now.getDate()-1}T00:00`;
  const lastDayOfMonth = new Date(year, now.getMonth() + 1, 0); 
  const formattedLastDay = `${year}-${month}-${String(lastDayOfMonth.getDate()).padStart(2, '0')}T23:59`;


  const handleDateChange = (event) => {
    // Format with IST offset (+05:30) instead of converting to UTC via toISOString()
    const localDate = new Date(event.target.value);
    const year = localDate.getFullYear();
    const month = String(localDate.getMonth() + 1).padStart(2, '0');
    const day = String(localDate.getDate()).padStart(2, '0');
    const hours = String(localDate.getHours()).padStart(2, '0');
    const minutes = String(localDate.getMinutes()).padStart(2, '0');
    const seconds = String(localDate.getSeconds()).padStart(2, '0');
    
    const istISOString = `${year}-${month}-${day}T${hours}:${minutes}:${seconds}+05:30`;
    setSelectedDate(istISOString);
  };

  return (
    <TextField
      label={label}
      type="datetime-local"
      value={selectedDate}
      onChange={handleDateChange}
      InputLabelProps={{
        shrink: true,
      }}
      // inputProps={{
      //   min: firstDayOfMonth,
      //   max: formattedLastDay,
      // }}
      fullWidth
    />
  );
};

export default DateTimeComponent;
